import classNames from 'classnames';
import React from 'react';
import { useUserContext } from '../../contexts';
import useDarkMode from '../../theme/useDarkMode';
import { useActionItems } from './actionItems';
import NavDropdown from './NavDropdown';
import { useNavItems } from './navItems';

type Props = {
  isAdminPage: boolean;
};
export default function DesktopDropdown({ isAdminPage }: Props) {
  const { user } = useUserContext();
  const { isDarkMode, toggle: toggleTheme } = useDarkMode();
  const navItems = useNavItems();
  const actionItems = useActionItems({ isAdminPage });

  return (
    <>
      {process.env.NODE_ENV === 'development' && (
        <button
          type="button"
          aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
          onClick={toggleTheme}
          className="flex items-center text-white mr-3"
        >
          <span className="material-icons text-[18px]">{isDarkMode ? 'light_mode' : 'dark_mode'}</span>
        </button>
      )}
      <NavDropdown
        items={[...(isAdminPage ? [] : [navItems.upgrade, navItems.accountSettings]), ...actionItems]}
        dropdownBody={
          <button
            className={classNames(
              'flex items-center cursor-pointer leading-3]',
              user?.secretMode ? 'text-blur-white' : 'text-white',
            )}
          >
            <span className="text-base">{user?.email as string}</span>
            <span className="text-white material-icons text-[18px] ml-1">arrow_drop_down</span>
          </button>
        }
      />
    </>
  );
}
